import React  from "react";

/*

*/
const ContactSnippet = (props) => {
  //console.log(props);
  const schema = {
    "@context": "http://schema.org",
    "@type": "Store",
    name: props.cfg.name,
    //alternateName: "",
    url: props.cfg.urlBase,
    address: props.cfg.address + " " + props.cfg.city + " - " +props.cfg.country,
    telephone: props.cfg.phone,
    logo: props.cfg.urlBase + "images/logo_schema.png",
    image: "/images/socialshare.png",
    //priceRange: "",
    //openingHours: props.cfg.openingHours,
    //geo: {"@type": "GeoCoordinates",latitude: "",longitude: ""},    
    currenciesAccepted: "EUR",
    //paymentAccepted: "",
   };
 
  return (
    <script
      key={`contactsJSON`}
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );    
};

export default ContactSnippet;